<template>
  <div class="san-gao-amount-page">
    <header class="hero">
      <p class="hero-slogan">三高修复·健康重启</p>
      <p class="hero-description">专业治疗·长期管理</p>
    </header>

    <main class="page-content">
      <section class="amount-card">
        <div class="section-title">
          <span>01</span>
          <h1>到会礼现场收款</h1>
          <i></i>
        </div>
        <p class="card-description">请输入本次实际收款金额</p>

        <div class="amount-input" :class="{ focused: amountFocused }">
          <span>￥</span>
          <van-field
            v-model="amount"
            type="number"
            input-align="right"
            placeholder="0.00"
            maxlength="9"
            @focus="amountFocused = true"
            @blur="amountFocused = false"
          />
        </div>
        <p class="amount-hint">最低支付 1 元，金额最多保留两位小数</p>

        <div class="payment-row">
          <span class="wechat-icon"><van-icon name="wechat" /></span>
          <span>
            <strong>微信支付</strong>
            <small>由当前微信账号完成付款</small>
          </span>
          <van-icon class="selected-icon" name="checked" />
        </div>

        <div class="business-tip">
          <van-icon name="info-o" />
          <span>本入口仅登记现场收款金额，不选择具体到会礼项目。</span>
        </div>
      </section>
    </main>

    <footer class="checkout-bar">
      <div class="total-copy">
        <span>应付金额</span>
        <strong><em>￥</em>{{ displayAmount }}</strong>
      </div>
      <button type="button" class="pay-button" :disabled="loading" @click="submitPayment">
        {{ loading ? "支付处理中" : "确认并付款" }}
      </button>
    </footer>

    <van-overlay :show="loading">
      <van-loading class="loading" size="40" vertical>支付中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from "vant";
import { onSettleInfoSubmitSanGaoDaoHuiLiAmount } from "@/api";
import { weixinInit } from "@/utils/wechatUtil.js";
import sanGaoShareImage from "@/assets/sanGao/share-card.jpg";

export default {
  name: "SanGaoDaoHuiLiAmount",
  data() {
    return {
      amount: "",
      amountFocused: false,
      loading: false,
      orgId: "",
    };
  },
  computed: {
    displayAmount() {
      const value = Number(this.amount);
      if (!Number.isFinite(value) || value <= 0) return "0.00";
      return value.toLocaleString("zh-CN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  created() {
    this.orgId = this.$route.query.orgId || localStorage.getItem("orgId") || "";
    this.initWechat();
  },
  methods: {
    async initWechat() {
      await weixinInit({
        publicType: this.$route.query.publicType || localStorage.getItem("publicType") || 2,
        url: window.location.href.split("#")[0],
        title: "三高修复·健康重启",
        desc: "专业治疗·长期管理",
        imgUrl: new URL(sanGaoShareImage, window.location.origin).href,
      });
    },
    validateAmount() {
      const value = String(this.amount || "").trim();
      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        return "请输入正确的支付金额，最多保留两位小数";
      }
      const amount = Number(value);
      if (amount < 1) return "支付金额不能小于1元";
      if (amount > 999999.99) return "单笔支付金额不能超过999999.99元";
      return "";
    },
    async submitPayment() {
      if (this.loading) return;
      if (!this.orgId) {
        Toast("当前机构信息为空，请重新扫码进入支付");
        return;
      }
      const error = this.validateAmount();
      if (error) {
        Toast(error);
        return;
      }

      this.loading = true;
      try {
        const response = await onSettleInfoSubmitSanGaoDaoHuiLiAmount({
          wxCode: localStorage.getItem("code") || "",
          saleOrgId: this.orgId,
          price: Number(this.amount).toFixed(2),
        });
        if (response.code === 200 && response.data) {
          this.weixinPay(response.data);
        } else {
          Toast(response.msg || "提交失败，请重试");
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        Toast("网络异常，请稍后重试");
      }
    },
    weixinPay(payParams) {
      const invokePay = () => {
        window.WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: payParams.appId,
            timeStamp: payParams.timeStamp,
            nonceStr: payParams.nonceStr,
            package: payParams.packages,
            signType: payParams.signType,
            paySign: payParams.paySign,
          },
          result => {
            this.loading = false;
            if (result.err_msg === "get_brand_wcpay_request:ok") {
              window.location.href = `${window.location.origin}/sanGaoDaoHuiLiInfoSuccess?payNo=${payParams.payNo}`;
            } else if (result.err_msg !== "get_brand_wcpay_request:cancel") {
              Toast("支付未完成，请重试");
            }
          }
        );
      };

      if (typeof window.WeixinJSBridge === "undefined") {
        document.addEventListener("WeixinJSBridgeReady", invokePay, false);
      } else {
        invokePay();
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.san-gao-amount-page {
  position: relative;
  min-height: 100vh;
  padding-bottom: 104px;
  overflow: hidden;
  color: #163451;
  background: #0874ca;
}

.san-gao-amount-page::before,
.san-gao-amount-page::after {
  position: fixed;
  inset: 0;
  content: "";
  pointer-events: none;
}

.san-gao-amount-page::before {
  z-index: 0;
  background: url("../../assets/sanGao/background.jpg") center -86px / cover no-repeat;
  opacity: 0.5;
}

.san-gao-amount-page::after {
  z-index: 0;
  background: linear-gradient(180deg, rgba(0, 75, 164, 0.1) 0%, rgba(196, 235, 255, 0.62) 42%, #dff6ff 100%);
}

.hero,
.page-content,
.checkout-bar {
  position: relative;
  z-index: 1;
}

.hero {
  height: 270px;
  padding: 76px 24px 0;
  color: #fff;
  text-shadow: 0 3px 16px rgba(0, 48, 113, 0.45);
}

.hero-slogan {
  margin: 0;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.28;
  letter-spacing: 2.5px;
}

.hero-description {
  margin-top: 14px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 3px;
  opacity: 0.94;
}

.page-content {
  padding: 0 16px;
}

.amount-card {
  padding: 24px 18px 22px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 10px 30px rgba(12, 91, 147, 0.14);
  backdrop-filter: blur(8px);
}

.section-title {
  display: flex;
  align-items: center;
}

.section-title span {
  margin-right: 9px;
  font-size: 11px;
  font-weight: 700;
  color: #38a1e8;
}

.section-title h1 {
  margin: 0;
  font-size: 18px;
  color: #163b5c;
}

.section-title i {
  flex: 1;
  height: 1px;
  margin-left: 12px;
  background: linear-gradient(90deg, #b8def5, transparent);
}

.card-description {
  margin: 22px 0 10px;
  font-size: 13px;
  color: #66869d;
}

.amount-input {
  display: flex;
  height: 72px;
  align-items: center;
  padding: 0 16px;
  border: 1px solid #cde4f3;
  border-radius: 14px;
  background: #f3faff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.amount-input.focused {
  border-color: #168de0;
  box-shadow: 0 0 0 3px rgba(22, 141, 224, 0.1);
}

.amount-input > span {
  font-size: 24px;
  font-weight: 700;
  color: #1a7ec4;
}

.amount-input /deep/ .van-cell {
  padding: 0;
  background: transparent;
}

.amount-input /deep/ .van-field__control {
  font-size: 30px;
  font-weight: 700;
  color: #173c5d;
}

.amount-input /deep/ input::placeholder {
  color: #a9c3d5;
}

.amount-hint {
  margin: 9px 2px 24px;
  font-size: 11px;
  color: #8ba5b7;
}

.payment-row {
  display: flex;
  min-height: 70px;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid #b8ddf3;
  border-radius: 13px;
  background: #ebf8ff;
}

.wechat-icon {
  display: flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(135deg, #27b1e9, #1979d6);
}

.wechat-icon .van-icon {
  font-size: 22px;
}

.payment-row > span:nth-child(2) {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.payment-row strong {
  margin-bottom: 4px;
  font-size: 14px;
}

.payment-row small {
  font-size: 11px;
  color: #7d9bb0;
}

.selected-icon {
  font-size: 20px;
  color: #168de0;
}

.business-tip {
  display: flex;
  align-items: flex-start;
  margin-top: 18px;
  padding: 12px;
  font-size: 11px;
  line-height: 1.6;
  color: #7896aa;
  border-radius: 10px;
  background: #f6fafc;
}

.business-tip .van-icon {
  margin: 2px 6px 0 0;
  color: #51a5db;
}

.checkout-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  min-height: 86px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-radius: 22px 22px 0 0;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 -6px 24px rgba(19, 91, 143, 0.12);
}

.total-copy {
  display: flex;
  flex-direction: column;
}

.total-copy span {
  margin-bottom: 3px;
  font-size: 11px;
  color: #7896aa;
}

.total-copy strong {
  font-size: 21px;
  color: #e7772f;
}

.total-copy em {
  font-size: 12px;
  font-style: normal;
}

.pay-button {
  min-width: 156px;
  height: 48px;
  border: 0;
  border-radius: 24px;
  font-size: 16px;
  color: #fff;
  background: linear-gradient(135deg, #20ace5, #1673d5);
  box-shadow: 0 8px 18px rgba(22, 116, 208, 0.24);
}

.pay-button:disabled {
  opacity: 0.7;
}

.loading {
  position: absolute;
  top: 42%;
  left: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
}
</style>
